export const LOCALE_SUBDOMAIN_MAPPING = {
  en: 'www',
  en_GB: 'uk',
  de: 'de',
  fr: 'fr',
  it: 'it',
  es: 'es',
  pt: 'pt',
  pl: 'pl',
  sv: 'se',
  uk: 'ua'
};
